import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=c0f70fa2&scoped=true&"
import script from "./Steps.vue?vue&type=script&lang=js&"
export * from "./Steps.vue?vue&type=script&lang=js&"
import style0 from "./Steps.vue?vue&type=style&index=0&id=c0f70fa2&prod&lang=css&"
import style1 from "./Steps.vue?vue&type=style&index=1&id=c0f70fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f70fa2",
  null
  
)

export default component.exports